class Lot {

  constructor(
    lots = []
  ) {
    this.lots = lots;
  }

  /**
  * Devuelve el área de la parcela con el ID especificado.
  *
  * @param {Number} lotId: el ID de la asignación.
  * @returns {Number|null} El área de la asignación, o nulo si no existe ninguna asignación con el ID especificado.
  */
  getAllotmentAreaById(lotId) {
    const lot = this.lots.find((lot) => Number(lot.id) === Number(lotId));

    return lot ? lot.area : null;
  }
}

export default Lot;
